import axios from 'axios';
import get from 'lodash/get'

import { BASE_API_URL } from 'utils/app-constants';
import { ErrorSubject } from 'shared/ErrorSubject';
import Auth from 'shared/Auth';

const instance = axios.create({
  baseURL: BASE_API_URL
});

/**
 * Intercept every request and append the authorization header
 */
instance.interceptors.request.use((config) => {
  const token = Auth.getToken();

  if (token) {
    config.headers.common['Authorization'] =  `Bearer ${token}`;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

/**
 * Intercept every response to see if the token has expired and requires a refresh
 */
instance.interceptors.response.use((response) => {
  return response;
}, (error) => {
  let errorSubject = JSON.parse(JSON.stringify(error));

  // Display no connection  
   (errorSubject);

  if (!get(errorSubject, 'response')) {
    console.log(error);
    ErrorSubject.next({ connectivity: false, errorSubject});
  }

  return Promise.reject(error);
}); 

export default instance;


// WEBPACK FOOTER //
// ./src/utils/axios.js